import type {
  UpdateContractItemMutationOptions,
  UpdateContractItemMutationVariables,
} from './types';

import { useMutation } from '@tanstack/react-query';

import { updateContractItem } from './updateContractItem';

/**
 * Custom hook for updating an existing line item in a contract.
 * This is a partial update - only provided fields are updated.
 *
 * @param options - Additional options for the mutation.
 * @returns An object containing the mutation function and related properties.
 * @see https://app.dev.vestigas.com/redoc#tag/Contracts/operation/update_contract_item_contracts__contract_id__items__item_id__put
 */
export const useMutationUpdateContractItem = (
  options?: UpdateContractItemMutationOptions,
) =>
  useMutation({
    mutationFn: async ({
      contractId,
      itemId,
      payload,
    }: UpdateContractItemMutationVariables) =>
      updateContractItem(contractId, itemId, payload),
    ...options,
  });
